import { newReconServiceAPI } from "./APIutils";
import { NEW_BASE_URL } from "../Constant";

export function uploadOndcReport(data) {
  const url = `${NEW_BASE_URL}/v1/ondc/upload`;
  return newReconServiceAPI(url, data, false, true, true);
}
